module.exports = __webpack_public_path__ + "img/spins_page_1248.6fe553f8.png";